import React from 'react';
import Spacing from '../Spacing';
import SectionHeadingStyle3 from '../SectionHeading/SectionHeadingStyle3';
import { Icon } from '@iconify/react';
import { pageTitle } from '../../helpers/PageTitle';
import { Link } from 'react-router-dom';

export default function Portfolio2() {
  pageTitle('Maragua Public School - Solar Power System');
  return (
    <>
      <Spacing lg="70" md="70" />
      <Spacing lg="140" md="80" />
      <SectionHeadingStyle3
        title="Solar Power System Installation"
        subTitle="Educational Institution"
      />
      <Spacing lg="75" md="60" />
      <div className="container">
        <div className="cs_portfolio_details">
          <img src="/images/portfolio/public-school-install-1.jpg" alt="School Solar Installation" />
          <Spacing lg="100" md="40" />
          <div className="cs_portfolio_details_in">
            <ul className="cs_portfolio_details_info cs_mp0">
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Client Type:</h3>
                <p className="mb-0">Public School</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Location:</h3>
                <p className="mb-0">Maragua, Kenya</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">Duration:</h3>
                <p className="mb-0">1 Month</p>
              </li>
              <li>
                <h3 className="cs_fs_21 mb-0 cs_semibold">
                  Project Completed:
                </h3>
                <p className="mb-0">January 2024</p>
              </li>
            </ul>
            <div className="cs_portfolio_details_right">
              <h2>Project Summary</h2>
              <p>
                This transformative project provided Maragua Public School with a comprehensive solar power system, enabling reliable electricity access for improved learning conditions and reduced operational costs.
                <br />
                The installation powers classrooms, administrative offices, and computer labs, supporting the school's digital learning initiatives.
              </p>
              <p>
                Project Impact:
              </p>
              <ul>
                <li>Reliable power for 20 classrooms</li>
                <li>Computer lab power backup system</li>
                <li>Energy cost reduction by 85%</li>
                <li>Enhanced evening study programs</li>
                <li>Improved learning environment</li>
              </ul>
            </div>
          </div>
          <Spacing lg="115" md="60" />
          <div className="cs_portfolio_details_gallery">
            <div>
              <img src="/images/portfolio/public-school-install-2.jpg" alt="Solar Panels" />
            </div>
            <div>
              <img src="/images/portfolio/public-school-install-3.jpg" alt="Computer Lab" />
            </div>
            <div>
              <img src="/images/portfolio/public-school-install-4.jpg" alt="Classroom Lighting" />
            </div>
          </div>
        </div>
        <Spacing lg="90" md="60" />
        <div className="cs_page_navigation cs_center">
          <div>
            <Link to="/portfolio/portfolio-1" className="cs_text_btn cs_type1">
              <Icon icon="cil:arrow-left" className="cs_fs_21" />
              <span>Prev Project</span>
            </Link>
          </div>
          <div>
            <Link to="/portfolio/portfolio-3" className="cs_text_btn">
              <span>Next Project</span>
              <Icon icon="cil:arrow-right" className="cs_fs_21" />
            </Link>
          </div>
        </div>
      </div>
      <Spacing lg="150" md="80" />
    </>
  );
} 